import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Box, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { VersionThreadMessage } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

type VersionMessageProps = {
    index: number;
    message: VersionThreadMessage;
    onClick?: (id: string) => void;
    isDisabled?: boolean;
    isCurrent?: boolean;
    messageRef?: React.RefObject<HTMLDivElement | null>;
};

export const VersionMessage = ({ index, message, onClick, isDisabled, isCurrent, messageRef }: VersionMessageProps) => {
    return (
        <Box
            border={`1px solid ${colorsPalettes.carbon[50]}`}
            borderRadius="6px"
            padding="12px  16px"
            ref={messageRef}
            data-automation={`version-container-${index + 1}`}
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
                display="block"
                data-automation="version-index"
            >
                {`${translate("si.pages.ai_agent_email.panel.version")} ${index + 1} -`}
            </Text>
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
                display="block"
                data-automation="version-content"
            >
                {message.content}
            </Text>
            {isCurrent ? (
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[300]}
                    display="block"
                    data-automation="version-current"
                >
                    {translate("si.pages.ai_agent_email.panel.version_current")}
                </Text>
            ) : (
                <Button
                    type="flat"
                    onClick={() => onClick?.(message.id)}
                    isDisabled={isDisabled}
                    data-automation="version-revert-button"
                >
                    {translate("si.pages.ai_agent_email.panel.revert_version")}
                </Button>
            )}
        </Box>
    );
};
